<template>
    <div class="oferta-wrap">
        <div class="close">
            <button @click="$emit('closeSoglashenie')">закрыть</button>
        </div>
        <div class="container">
            <h1>Соглашение об обработке персональных данных</h1>

            <h2>Присоединяясь к настоящему Соглашению и оставляя свои данные на сайте https://medpervichka.ru/ (далее – Сайт), путем заполнения полей формы записи на прием, формы обратной связи, или формы комментариев (далее – Форма), Пользователь:</h2>
            <ul>
                <li>подтверждает, что все указанные им данные и информация являются полными, точными и достоверными;</li>
                <li>гарантирует, что при предоставлении данных и информации не нарушается действующее законодательство Российской Федерации, законные права и интересы третьих лиц;</li>
                <li>подтверждает и признает, что им внимательно в полном объеме прочитано Соглашение и условия обработки персональных данных, указываемых в полях Формы, текст настоящего Соглашения и данные условия обработки персональных данных ясны и понятны;</li>
                <li>дает согласие на обработку Сайтом предоставляемых в составе информации персональных данных в целях заключения между ним и Сайтом настоящего Соглашения, а также его последующего исполнения;</li>
                <li>выражает согласие с условиями обработки персональных данных;</li>
                <li>дает согласие на получение информационной рассылки о новостях Сайта, в том числе анонсов статей, размещенных на Сайте, и рекламных материалов от партнеров Сайта.</li>
            </ul>

            <p>Пользователь дает свое согласие на обработку персональных данных, а именно совершение действий, предусмотренных п. 3 ч. 1 ст. 3 Федерального закона от 27.07.2006 N 152-ФЗ «О персональных данных» в редакции, действующей на момент обработки таких персональных данных, и подтверждает, что, давая такое согласие, он действует свободно, своей волей и в своем интересе.</p>
            <p>Согласие Пользователя на обработку персональных данных является конкретным, информированным и сознательным.</p>

            <h2>Настоящее согласие Пользователя признается исполненным в простой письменной форме, на обработку следующих персональных данных:</h2>
            <ul>
                <li>фамилии, имени, отчества;</li>
                <li>даты рождения;</li>
                <li>места пребывания (город, область);</li>
                <li>номеров телефонов; </li>
                <li>адресов электронной почты и иных каналов связи.</li>
            </ul>

            <p>Пользователь, предоставляет Сайту право осуществлять следующие действия (операции) с персональными данными: сбор и накопление; хранение в течение установленных нормативными документами сроков хранения отчетности; уточнение (обновление, изменение); использование; уничтожение; обезличивание; передача по требованию суда и органов дознания, предварительного следствия, в том числе третьим лицам, с соблюдением законных мер, обеспечивающих защиту персональных данных от несанкционированного доступа.</p>
            <p>Указанное согласие действует бессрочно с момента предоставления данных и может быть отозвано Вами путем подачи заявления администрации сайта с указанием данных, определенных ст. 14 ФЗ «О персональных данных».</p>
            <p>Пользователь, как субъект персональных данных, вправе требовать от Сайта уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав.</p>
            <p>Отзыв согласия на обработку персональных данных может быть осуществлен путем направления Пользователем соответствующего распоряжения в простой письменной форме на адрес электронной почты info@medpervichka.ru.</p>
            <p>Целью сбора персональных данных Сайтом является использование данных исключительно для предоставления Пользователю возможность взаимодействовать с Сайтом и для обратной связи с Пользователем, в том числе для направления информации об услугах, акциях, а также для рекламных рассылок, в любой не запрещенной действующим законодательством форме.</p>
            <p>Сайт не несет ответственности за использование (как правомерное, так и неправомерное) третьими лицами Информации, размещенной Пользователем на Сайте, включая её воспроизведение и распространение, осуществленные всеми возможными способами.</p>
            <p>Сайт имеет право вносить изменения в настоящее Соглашение. При внесении изменений в актуальной редакции указывается дата последнего обновления. Новая редакция Соглашения вступает в силу с момента ее размещения, если иное не предусмотрено новой редакцией Соглашения.</p>
            <p>К настоящему Соглашению и отношениям между пользователем и Сайтом, возникающим в связи с применением Соглашения, подлежит применению право Российской Федерации.</p>

            <p>Владельцем Сайта является ИП Антропов Руслан Александрович ОГРНИП 322784700255063, ИНН 780521136219</p>
            <p>Адрес местонахождения: 198330 Санкт-Петербург Город, Ленинский Проспект, дом 95, корп. 1, кв./офис 123</p>
            <p>Почтовый адрес: 198330 Санкт-Петербург Город, Ленинский Проспект, дом 95, корп. 1, кв./офис 123</p>
            <p>Контактная информация оператора: телефон: +89119180235, E-mail info@medpervichka.ru.</p>
            <p>С полной редакцией текста «Политики обработки и защиты персональных данных https://medpervichka.ru/. Вы можете ознакомиться: <a href="https://medpervichka.ru/">здесь</a>.</p>
            

        </div>
        <div class="close">
            <button @click="$emit('closeSoglashenie')">закрыть</button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SoglashenieBlock',
    components: {},
    emits: [ 'closeSoglashenie' ],
    props: {},
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
<style lang="scss">
.Soglashenie-wrap{
    $color: #fff;
    $bg: #45289C;
    // $color: #000000;
    // $bg: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    z-index: 1050;
    // background-color: #243255;
    // color: #fff;
    background-color: $bg;
    color: $color;
    text-align: left;
    h1{
        text-align: center;
        color: $color !important;
    }
    h1,p{
        margin: 1em;
    }
    a{
        color: $color;
    }
    ol{
        // color: $color !important;
        counter-reset: num;
        list-style: none;
        line-height: 1.25em;
        padding: 0;
        margin: 0;
        &>li{
            counter-increment: num;
            margin-top: 4px;
            margin-bottom: 4px;
            // &:first-child{
            //     text-transform: uppercase;
            //     font-weight: 600;
            // }
            &::before{
                content: counter(num)'.';
                padding: 0 8px 0 0;
            }
            &>ol{
                padding: 0;
                margin: 0;
                counter-reset: num2;
                &>li{
                    counter-increment: num2;
                    &::before{
                        content: counter(num) '.' counter(num2) '.';
                    }
                    &>ol{
                        counter-reset: num3;
                        &>li{
                            counter-increment: num3;
                            &::before{
                                content: counter(num) '.' counter(num2) '.' counter(num3) '.';
                            }
                        }
                    }
                }
            }
        }
        ul{
            list-style: none;
            li{
                margin-top: 4px;
                margin-bottom: 4px;
                &::before{
                    content: '—';
                    padding: 0 8px 0 0;
                }
            }
        }
    }
    // ol{
    //     // padding: 1em;
    //     margin: 1em;
    //     li{
    //         margin-bottom: .5em;
    //     }
    // }
    .close{
        text-align: center;
        padding: 1em;
        button{
            background-color: transparent;
            border: none;
            color: $color;
            border-bottom: solid 1px $color;
        }
    }
}
</style>